import { Checkbox, FormLabel, Radio, RadioGroup, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ChangeEvent, useState } from 'react';
import { FormContainer } from 'react-hook-form-mui';
import DataContainer from '../../../Utilities/DataContainer';
import ExportTripRateLineGraphViewModel from '../../ViewModels/ExportTripRateLineGraphViewModel';



interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    exportFiltersViewModel: (vm: ExportTripRateLineGraphViewModel) => void;
}

export default function ExportTripRateLineGraphDialog({ dialogOpen, handleClose, exportFiltersViewModel }: IProps) {

    const [exportFilters, setExportFilters] = useState(new ExportTripRateLineGraphViewModel());


    const handleText = (e: ChangeEvent<HTMLInputElement>) => {
        setExportFilters(f => ({
            ...f,
            [e.target.name]: (e.target as HTMLInputElement).value
        }))
    }
    const handleCheck = (e: ChangeEvent<HTMLInputElement>) =>
        setExportFilters(f => ({ ...f, [e.target.name]: e.target.checked }));


    const handleRadio = (name: keyof ExportTripRateLineGraphViewModel) =>
        (e: React.ChangeEvent<HTMLInputElement>) =>
            setExportFilters(f => ({
                ...f,
                [name]: e.target.value as ExportTripRateLineGraphViewModel["exportType"]
            }));

    return (
        <Dialog open={dialogOpen} onClose={handleClose} maxWidth="sm" >
            <DialogTitle>
                <Stack>
                    <Typography variant={'h5'}>Trip Rate Line Graph Export</Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Grid container size={12}>
                    <Grid size={12}>
                        <DataContainer title={"Export Settings"}>
                            <FormContainer>
                                <RadioGroup
                                    row
                                    name="type"
                                    value={exportFilters.exportType}
                                    onChange={handleRadio('exportType')}
                                >
                                    <FormControlLabel
                                        value="PDF"
                                        control={<Radio size="small" />}
                                        label="PDF"
                                    />
                                    <FormControlLabel
                                        value="CSV"
                                        control={<Radio size="small" />}
                                        label="CSV"
                                    />
                                    <FormControlLabel
                                        value="JPEG"
                                        control={<Radio size="small" />}
                                        label="JPEG"
                                    />
                                </RadioGroup>
                                {exportFilters.exportType == "PDF" &&
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="addUserComments"
                                                    checked={exportFilters.addUserComments}
                                                    onChange={handleCheck}
                                                    size="small"
                                                />
                                            }
                                            label="Add User Comments"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="displayDirectlyToScreen"
                                                    checked={exportFilters.displayToScreen}
                                                    onChange={handleCheck}
                                                    size="small"
                                                />
                                            }
                                            label="Display PDF directly to screen"
                                        />
                                        <Stack spacing={1}>
                                            <FormLabel>File Name</FormLabel>
                                            <TextField
                                                name="fileName"
                                                value={exportFilters.fileName}
                                                onChange={handleText}
                                                size="small"
                                            />
                                        </Stack>
                                        {exportFilters.addUserComments &&
                                            <Stack spacing={1}>
                                                <FormLabel>Comments</FormLabel>
                                                <TextField
                                                    name="userComments"
                                                    value={exportFilters.userComment}
                                                    onChange={handleText}
                                                    size="small"
                                                />
                                            </Stack>
                                        }
                                    </FormGroup>
                                }
                            </FormContainer>
                        </DataContainer>
                    </Grid>
                </Grid>
            </DialogContent >
            <DialogActions>
                <Grid container size={12}>
                    <Stack direction="row" spacing={2}>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button onClick={() => exportFiltersViewModel(exportFilters)}>Submit</Button>
                    </Stack>
                </Grid>
            </DialogActions>
        </Dialog >

    );
}